import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=77b4f931&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=77b4f931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4f931",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b4f931')) {
      api.createRecord('77b4f931', component.options)
    } else {
      api.reload('77b4f931', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=77b4f931&scoped=true&", function () {
      api.rerender('77b4f931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/comp/DocBox.vue"
export default component.exports